export default __webpack_public_path__ + "static/media/no-disposal-black.4b263c7f.svg";